import type { JSX } from "react";
import { memo } from "react";
import clsx from "clsx";

import styles from "./styles.module.scss";

import { Icon } from "@components/atoms/icons";
import type { IPaginationActionProps } from "@components/molecules/pagination/types";
import { PaginationLink } from "@components/molecules/pagination/paginationLink";

export const PaginationPrevious = memo(function PaginationPrevious({
  disabled,
  ...props
}: IPaginationActionProps): JSX.Element {
  return (
    <PaginationLink
      aria-label={"Go to previous page"}
      size={"default"}
      className={clsx(styles.prevButton)}
      {...props}
      disabled={disabled}
    >
      <Icon name={"AltArrowRight"} type={"linear"} />
      {props.children}
    </PaginationLink>
  );
});
